import { CommonModule } from '@angular/common'
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { DateInputsModule } from '@progress/kendo-angular-dateinputs'
import { DropDownsModule } from '@progress/kendo-angular-dropdowns'
import { GridModule } from '@progress/kendo-angular-grid'
import { InputsModule } from '@progress/kendo-angular-inputs'
import { TabStripModule } from '@progress/kendo-angular-layout'
import { FeatureToggleModule } from 'ngx-feature-toggle'
import { QuillModule } from 'ngx-quill'

import { CyborgUIModule } from '@cyborg-monorepo/common/angular/cyborg-ui'
import {
  AccordionComponent,
  BadgeComponent,
  ButtonComponent,
  ButtonMenuComponent,
  CheckboxComponent,
  CodeBlockComponent,
  DropdownMenuComponent,
  DropdownMenuItemComponent,
  ErrorComponent,
  HyperkitComponent,
  IconComponent,
  InputComponent,
  LinkComponent,
  MarkdownComponent,
  MultiSelectComponent,
  ProgressBarComponent,
  SegmentedProgressBarComponent,
  SelectComponent,
  TabBarComponent,
  TabComponent,
  TextAreaComponent,
  ToggleComponent,
  TooltipComponent,
  TypographyComponent,
} from '@hyperkit'

import { FeatureFlagService } from '../../helpers/feature-flag.service'
import { SharedModule } from '../shared/shared.module'

import { ArchiveGateComponent } from './archive-gate/archive-gate.component'
import { ArchiveHuntTemplateGuard } from './archived-hunt-template.guard'
import { ArchiveHuntGuard } from './archived-hunt.guard'
import { ArchiveHuntDialogComponent } from './dialogs/archive-hunt-dialog/archive-hunt-dialog.component'
import { EditHuntDialogComponent } from './dialogs/edit-hunt-dialog/edit-hunt-dialog.component'
import { CustomHuntPackageComponent } from './hunt-template/custom-hunt-package/custom-hunt-package.component'
import { EditTemplateDialogComponent } from './hunt-template/edit-template-dialog/edit-template-dialog.component'
import { HuntTemplateComponent } from './hunt-template/hunt-template.component'
import { HuntManagementComponent } from './hunt.component'
import { ArchiveTemplateDialogComponent } from './overview/archive-template-dialog/archive-template-dialog.component'
import { DashboardFilterComponent } from './overview/dashboard/dashboard-filter/dashboard-filter.component'
import { DashboardDateRangeFilterComponent } from './overview/dashboard/dashboard-filter/dashboard-filters/dashboard-date-range-filter.component'
import { DashboardDropDownFilterComponent } from './overview/dashboard/dashboard-filter/dashboard-filters/dashboard-dropdown-filter.component'
import { DashboardEnvironmentFilterComponent } from './overview/dashboard/dashboard-filter/dashboard-filters/dashboard-environment-filter.component'
import { DashboardTagFilterComponent } from './overview/dashboard/dashboard-filter/dashboard-filters/dashboard-tag-filter.component'
import { DashboardStateService } from './overview/dashboard/dashboard-state-service'
import { DashboardUrlService } from './overview/dashboard/dashboard-url-service'
import { DashboardComponent } from './overview/dashboard/dashboard.component'
import { ExportOptionsDialogComponent } from './overview/dashboard/export-options-dialog/export-options-dialog.component'
import { HuntListComponent } from './overview/hunt-list/hunt-list.component'
import { HuntStateService } from './overview/hunt-list/hunt-state-service'
import { HuntUrlService } from './overview/hunt-list/hunt-url-service'
import { HuntTemplateListComponent } from './overview/hunt-template-list/hunt-template-list.component'
import { HuntTemplateStateService } from './overview/hunt-template-list/hunt-template-state-service'
import { OverviewComponent } from './overview/overview.component'
@NgModule({
  declarations: [
    HuntManagementComponent,
    OverviewComponent,
    HuntTemplateComponent,
    EditTemplateDialogComponent,
    EditHuntDialogComponent,
    ArchiveTemplateDialogComponent,
    ArchiveHuntDialogComponent,
    HuntListComponent,
    HuntTemplateListComponent,
    DashboardComponent,
    DashboardFilterComponent,
    DashboardEnvironmentFilterComponent,
    DashboardTagFilterComponent,
    DashboardDropDownFilterComponent,
    DashboardDateRangeFilterComponent,
    ExportOptionsDialogComponent,
    CustomHuntPackageComponent,
    ArchiveGateComponent,
  ],
  providers: [
    HuntUrlService,
    DashboardUrlService,
    DashboardStateService,
    HuntStateService,
    HuntTemplateStateService,
    ArchiveHuntGuard,
    ArchiveHuntTemplateGuard,
    FeatureFlagService,
  ],
  imports: [
    MarkdownComponent,
    SharedModule,
    CodeBlockComponent,
    IconComponent,
    HyperkitComponent,
    TypographyComponent,
    ButtonComponent,
    SegmentedProgressBarComponent,
    TabComponent,
    AccordionComponent,
    ErrorComponent,
    BadgeComponent,
    ButtonMenuComponent,
    DropdownMenuComponent,
    DropdownMenuItemComponent,
    TooltipComponent,
    TabBarComponent,
    TabComponent,
    TabBarComponent,
    InputComponent,
    MultiSelectComponent,
    SelectComponent,
    CheckboxComponent,
    TextAreaComponent,
    ProgressBarComponent,
    ToggleComponent,
    LinkComponent,
    CommonModule,
    CyborgUIModule,
    RouterModule,
    QuillModule.forRoot(),
    FeatureToggleModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class HuntModule {}
